<template>
    <div>
        <div class="flex items-center" v-if="refresh">
            <div class="mt-2">
                <span class="font-bold">{{codeStart}}</span>
                <span class="mx-2 font-bold">/</span>
            </div>
            <sav-input @input="emitData" maxlength="4" v-model="textValue" class="grow" type="text" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {},
    },

    watch: {
        value: function(value) {
            if (value != this.completeCode)  {
                this.setValue()
            }
        }
    },

    data() {
        return {
            codeStart: null,
            refresh: true,
            textValue: null
        }
    },

    computed: {
        completeCode() {
            return this.codeStart + '/' + this.textValue
        }
    },

    methods: {
        emitData() {
            this.$emit('input', this.completeCode)
        },

        setValue() {
            this.codeStart = this.value.split('/')[0]
            if (this.value.includes('/')) {
                this.textValue = this.value.split('/')[1]
            }
            this.refresh = false
            this.$nextTick(() => {
                this.refresh = true
            })
        }
    },

    mounted() {
        if (this.value) {
            this.setValue()
        }
    }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/SavInputIndiceSav.vue